module.exports = __webpack_public_path__ + "static/media/sodic_map.cb1a34a7.jpeg";